var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "root d-flex flex-row h-100", class: _vm.theme },
    [
      _c("div", { staticClass: "filenames" }, [
        _c(
          "div",
          { staticClass: "list-group" },
          [
            !_vm.zip
              ? _c(
                  "button",
                  {
                    staticClass:
                      "text-truncate list-group-item list-group-item-action disabled",
                    attrs: { type: "button" },
                  },
                  [_c("em", [_vm._v(_vm._s(_vm.T.wordsEmpty))])]
                )
              : _vm._l(_vm.zip.files, function (item, name) {
                  return _c(
                    "button",
                    {
                      key: name,
                      staticClass:
                        "text-truncate list-group-item list-group-item-action",
                      class: {
                        active: _vm.active === name,
                      },
                      attrs: { type: "button", title: name },
                      on: {
                        click: function ($event) {
                          return _vm.select(item)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(name) + " ")]
                  )
                }),
          ],
          2
        ),
      ]),
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.contents,
            expression: "contents",
          },
        ],
        staticClass: "editor",
        class: _vm.theme,
        attrs: { readonly: "" },
        domProps: { value: _vm.contents },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.contents = $event.target.value
          },
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }